import { THERAPIST_ROUTES_PREFIX } from '../therapist-planning/therapist-planning.path';

export const PATIENT_CHAT_LIST_PATHNAME = '/chat';
export const THERAPIST_CHAT_LIST_PATHNAME = `${THERAPIST_ROUTES_PREFIX}/chat`;
export const PATIENT_CHAT_PATHNAME = '/chat/:user';

export function buildChatPath(userId: string) {
  return `/chat/${encodeURIComponent(userId)}`;
}
